import z from 'zod'

import { MAX_SAFE_GQL_INTEGER } from 'providers/tanstack-query/constants'
import { RichPlacementMultianchor } from '../../hooks/useGetRichPlacementMultianchor'

export const schema = z.object({
  customStyling: z.string().default(''),
  displayAfterUserInteraction: z.boolean().default(false),
  fullWidthMode: z.boolean().default(false),
  showCloseButton: z.boolean().default(false),
  singleAdViewTime: z.number().min(2_000).max(MAX_SAFE_GQL_INTEGER).default(5_000),
})

export type Schema = z.infer<typeof schema>

export const schemaDefault = (multianchor: RichPlacementMultianchor): Schema => {
  const {
    customStyling,
    displayAfterUserInteraction,
    fullWidthMode,
    showCloseButton,
    singleAdViewTime,
  } = multianchor

  return {
    customStyling,
    displayAfterUserInteraction,
    fullWidthMode,
    showCloseButton,
    singleAdViewTime,
  }
}
